"use strict";

exports.__esModule = true;
var _ElementRenderer = require("./ElementRenderer");
Object.keys(_ElementRenderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementRenderer[key]) return;
  exports[key] = _ElementRenderer[key];
});